import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import reportingTermAcademicTranscriptSlice from "./slices/academicTranscriptSlice";
import reportingAssignmentDetailsSlice from "./slices/assignmentDetailsSlice";
import reportingCertificateSlice from "./slices/certificateSlice";
import reportingFeedbackDetailsReducer from "./slices/feedbackDetailsSlice";
import reportingGradeAcademicTranscriptSlice from "./slices/gradeAcademicTranscriptSlice";
import reportingGradeDetailReducer from "./slices/gradeDetailSlice";
import reportingLessonCurriculumSlice from "./slices/lessonCurriculumSlice";
import reportingQuizResultsSlice from "./slices/quizSlice";
import reportingStudentsSliceReducer from "./slices/studentsSlice";
import reportingSubmitFeedbackReducer from "./slices/submitFeedbackSlice";

export { default as useReportingDispatch } from "./useReportingDispatch";
export {
    useReportingSelector,
    useStudentEntitlementsSelector
} from "./useReportingSelector";

const reportingReducerRoot = combineReducers({
    reporting: reportingStudentsSliceReducer,
    gradeDetail: reportingGradeDetailReducer,
    lessonCurriculum: reportingLessonCurriculumSlice,
    feedbackDetails: reportingFeedbackDetailsReducer,
    submitFeedback: reportingSubmitFeedbackReducer,
    academicTranscript: reportingTermAcademicTranscriptSlice,
    assignmentDetails: reportingAssignmentDetailsSlice,
    quiz: reportingQuizResultsSlice,
    gradeAcademicTranscript: reportingGradeAcademicTranscriptSlice,
    certificate: reportingCertificateSlice
});

export type ReportingRootState = ReturnType<typeof reportingReducerRoot>;

const reportingPersistConfig = {
    key: "reporting",
    storage,
    blacklist: [
        "feedbackDetails",
        "academicTranscript",
        "gradeAcademicTranscript",
        "submitFeedback",
        "reporting",
        "certificate",
        // BLD1-1091: per-view fetched-on-demand slices must NOT be persisted.
        // They carry transient isLoading/status flags; if a session is
        // interrupted mid-fetch (navigate away / close tab) the PENDING flag
        // gets written to localStorage and rehydrated on a fresh direct load /
        // refresh. Nothing clears it when the follow-up fetch never fires
        // (e.g. a no-reports student), producing an infinite loading spinner.
        // These are always refetched on mount / via forceFetch, so persisting
        // them gives no benefit.
        "gradeDetail",
        "lessonCurriculum",
        "assignmentDetails",
        "quiz"
    ]
};

const persistedReportingReducer = persistReducer(
    reportingPersistConfig,
    reportingReducerRoot
);

export default persistedReportingReducer;
